import { useId, useState, type ReactNode } from "react";

export function InfoDisclosure({ label, children }: { label: string; children: ReactNode }): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const id = useId();
  return <div className="info-disclosure" onKeyDown={(event) => { if (event.key === "Escape") setOpen(false); }}>
    <button type="button" className="info-button" aria-label={label} aria-expanded={open} aria-controls={id} onClick={() => setOpen((value) => !value)}><span aria-hidden="true">i</span></button>
    {open && <div id={id} className="info-content">{children}</div>}
  </div>;
}
